import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import DigitalAgency from './pages/DigitalAgency';
import PortfolioDetails from './pages/PortfolioDetails';
import ErrorPage from './pages/Error';
import './assets/scss/style.scss';

const normalizePathname = (pathname = '/') => {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
};

export const resolveRoute = (pathname) => {
  const normalizedPathname = normalizePathname(pathname);

  if (normalizedPathname === '/') {
    return { type: 'home' };
  }

  const portfolioMatch = normalizedPathname.match(/^\/portfolio-details\/(\d+)$/);
  if (portfolioMatch) {
    return { type: 'portfolio', portfolioId: Number(portfolioMatch[1]) };
  }

  return { type: 'not-found' };
};

export const AppRoutes = ({ pathname = '/' }) => {
  const route = resolveRoute(pathname);

  if (route.type === 'home') {
    return <DigitalAgency />;
  }

  if (route.type === 'portfolio') {
    return <PortfolioDetails portfolioId={route.portfolioId} />;
  }

  return <ErrorPage />;
};

const getBrowserPathname = () => {
  if (typeof window === 'undefined') return '/';
  return window.location.pathname || '/';
};

const App = ({ pathname, helmetContext }) => (
  <HelmetProvider context={helmetContext}>
    <AppRoutes pathname={pathname || getBrowserPathname()} />
  </HelmetProvider>
);

export default App;
